import PropTypes from 'prop-types';
import React from 'react'
import ReactDOM from 'react-dom'

import { submitReply } from '~/actions/statement'


export default class extends React.Component {
    static propTypes = {
		parent: PropTypes.number,
		statementID: PropTypes.number.isRequired,
		onSubmission: PropTypes.func
	};

    static contextTypes = {
		store: PropTypes.object
	};

    componentDidMount() {
		ReactDOM.findDOMNode(this.refs.reply).focus(); 
	}

    submitReply = () => {

		let { session } = this.context.store.getState()

		let text = this.refs.reply.value.replace(/<\/?[^>]+(>|$)/g, "")
		if( text.replace(/ /g,'') == "" ) return false;

		let data = { reply: text }
		if( this.props.parent && this.props.parent > 0 ) data.parent = this.props.parent
		this.context.store.dispatch( submitReply( this.props.statementID, data, session.user ) )

		if( !!this.props.onSubmission ) this.props.onSubmission()
		this.closeReply()

	};

    closeReply = () => {
		this.props.toggleReplyBox(false)
	};

    render() {

		let { session } = this.context.store.getState()

		return (
			<div className={"col-sm-12 bg-pale-gray ptop5 pbot5 submit-item " + (!!this.props.parent ? 'reply-sub-item' : 'reply-item')}>
				<div className="profile-image-wrapper mright10">
					<div className="profile-image" style={{backgroundImage: 'url(' + session.user.profile_picture + ')'}}></div>
				</div>
				<div className="reply-content">
					<textarea className="form-control" ref="reply" rows="2"></textarea>
					<button className="btn btn-primary pull-right mtop5" onClick={this.submitReply}>Reply</button>
					<p className="small pull-right clickable text-light-grey mtop5 close-reply" onClick={this.closeReply}>
						<i className="icon-cross"></i>
					</p>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/ReplyParts/ReplyPart-Submit.jsx